import { Modal } from "@/modules/irohana-components/elements/Modal";
import { Stack, Typography } from "@mui/material";
import { FC, useEffect } from "react";
import { BlockerFunction, useBlocker, Location } from "react-router-dom";

type TConfirmLeavePageProps = {
  shouldBlock: boolean | BlockerFunction;
  callBackLeave?: () => void;
  customMessage?: string;
};

// Helper function to check if only query params changed
const isOnlyQueryParamsChanged = (currentLocation: Location, nextLocation: Location): boolean => {
  return currentLocation.pathname === nextLocation.pathname;
};

export const ConfirmLeavePage: FC<TConfirmLeavePageProps> = ({ shouldBlock, callBackLeave, customMessage }) => {
  // Wrap shouldBlock to skip blocking if only query params changed
  const modifiedShouldBlock: BlockerFunction = ({ currentLocation, nextLocation, historyAction }) => {
    if (typeof shouldBlock === "function") {
      // If shouldBlock is a function, call it but skip if only query params changed
      return !isOnlyQueryParamsChanged(currentLocation, nextLocation) && shouldBlock({ currentLocation, nextLocation, historyAction });
    }
    // If shouldBlock is a boolean, skip if only query params changed
    return !isOnlyQueryParamsChanged(currentLocation, nextLocation) && shouldBlock;
  };

  const blocker = useBlocker(modifiedShouldBlock);

  useEffect(() => {
    const beforeUnLoadHandler = (event: BeforeUnloadEvent) => {
      if (typeof shouldBlock === "function" || !shouldBlock) return;
      event.preventDefault();
      event.returnValue = "行った変更が保存されない可能性があります";
      return event;
    };
    window.addEventListener("beforeunload", beforeUnLoadHandler);
    return () => {
      window.removeEventListener("beforeunload", beforeUnLoadHandler);
    };
  }, [shouldBlock]);

  useEffect(() => {
    if (blocker.state === "blocked" && (typeof shouldBlock === "function" || !shouldBlock)) {
      blocker.proceed();
    }
  }, [shouldBlock, blocker]);

  if (blocker.state === "blocked" && (typeof shouldBlock === "function" || shouldBlock)) {
    return (
      <Modal
        isOpen
        onClose={() => {
          blocker.reset();
          callBackLeave?.();
        }}
        onOk={() => {
          blocker.proceed();
          callBackLeave?.();
        }}
        labelClose="いいえ"
        labelOk="はい"
      >
        <Stack mb={2}>
          <Typography>{customMessage || "入力したデータがなくなりますが、よろしいですか。"}</Typography>
        </Stack>
      </Modal>
    );
  }
  return null;
};
